/* eslint-disable no-case-declarations */
import { get } from "lodash";
import * as types from "~/store/payment/paymentType";

const initialState = {
  loading: false,
  data: [],
  selectedMethod: {},
  methodId: "NO_PAYMENT",
  showModal: false,
  errors: {},
  price: {
    subTotal: 0,
    totalFee: 0,
    grandTotal: 0,
    medproCareFee: 0,
    paidService: true
  }
};

export default function allPaymnetMethod(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALL_PAYMEN_MULTI_BOOKING_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.data],
        price: {
          ...state.price,
          subTotal: action.data[0].subTotal,
          totalFee: 0,
          grandTotal: action.data[0].subTotal,
          medproCareFee: action.data[0].medproCareFee,
          medproFee: action.data[0].medproFee
        }
      };

    case types.ACTIVE_STATUS_TRANSACTION:
      return {
        ...state,
        loopStatus: true
      };

    case types.STOP_GET_STATUS_TRANSACTION:
      return {
        ...state,
        loopStatus: false
      };

    case types.SET_PRICE_OF_SERVICE_ADD_ON:
      return {
        ...state,
        price: {
          ...state.price,
          priceOfSvAddOn: action.price
        }
      };

    case types.RESET_PAYMENT: {
      return { ...initialState };
    }

    case types.GET_ALL_PAYMENT_METHODS:
      return {
        ...state,
        loading: true
      };

    case types.GET_ALL_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.data],
        price: {
          ...state.price,
          subTotal: action.data[0].subTotal,
          totalFee: 0,
          grandTotal: action.data[0].grandTotal,
          medproCareFee: action.data[0].medproCareFee,
          medproFee: action.data[0].medproFee
        }
      };
    case types.GET_ALL_PAYMENT_METHODS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };
    case types.TOGGLE_MODAL_PAYMENT_METHOD:
      return {
        ...state,
        showModal: !state.showModal
      };
    case types.HIDE_MODAL_PAYMENT_METHOD:
      return {
        ...state,
        showModal: false
      };
    case types.SELECTED_PAYMENT_METHOD:
      const subTotalTemp = get(action, "method.subTotal", 0);
      const totalFeeTemp = get(action, "method.totalFee", 0);
      const grandTotalTemp = get(action, "method.grandTotal", 0);

      const partialSubTotal = get(action, "method.partialSubTotal", 0);
      const partialTotalFee = get(action, "method.partialTotalFee", 0);
      const partialGrandTotal = get(action, "method.partialGrandTotal", 0);

      const subTotal = action.paidService ? subTotalTemp : partialSubTotal;
      const totalFee = action.paidService ? totalFeeTemp : partialTotalFee;
      const grandTotal = action.paidService
        ? grandTotalTemp
        : partialGrandTotal;

      return {
        ...state,
        selectedMethod: { ...action.method },
        methodId: action.methodId,
        showModal: false,
        price: {
          ...state.price,
          subTotal,
          totalFee,
          grandTotal,
          paidService: action.paidService
        }
      };
    case types.RESET_ALL_PROPS_PAYMENT_METHOD:
      return {
        ...state,
        selectedMethod: initialState.selectedMethod,
        methodId: initialState.methodId
      };
    default:
      return state;
  }
}
